import { faBan } from '@fortawesome/pro-regular-svg-icons'

import { EmptyState, FormattedMessage } from '@b-stock/fe-core/bstock-react'

import { Link } from '@/buyer-portal/components/Link'
import { CONTACT_SUPPORT_URL } from '@/buyer-portal/helpers/constants'

const ns = 'Listing.errors.blockedBuyer'

export const BlockedBuyerErrorBanner = () => {
  return (
    <EmptyState
      icon={faBan}
      title={<FormattedMessage id={`${ns}.title`} />}
      description={
        <FormattedMessage
          id={`${ns}.description`}
          values={{
            link: (
              <Link target="_blank" href={CONTACT_SUPPORT_URL}>
                <FormattedMessage id={`${ns}.contactSupportLink`} />
              </Link>
            ),
          }}
        />
      }
      size={4}
    />
  )
}
